














import { Component, Vue } from 'vue-property-decorator'
import TechTaskCard, { DefaultServerResponse } from '@/components/ui/TechTaskCard.vue'
import AccountIdInput from '@/components/ui/AccountIdInput.vue'
import request from '@/helpers/requests'


enum SocialMediaSources {
    GOOGLE='google',
    FACEBOOK='facebook',
    BBB='bbb',
    YELLOWPAGES='yp',
    ANGIESLIST='angieslist',
    HOMESTAR='homestar',
    HOUZZ='houzz',
    HOMEADVISOR='homeadvisor',
    PORCH='porch',
    NEXTDOOR='nextdoor'
}

enum SocialMediaTitles {
    angieslist='Angie\'s List',
    bbb='Better Business Bureau',
    facebook='Facebook',
    google='Google',
    homeadvisor='HomeAdvisor',
    homestar='HomeStars',
    houzz='Houzz',
    nextdoor='Nextdoor',
    porch='Porch',
    yp='Yellow Pages'
}

interface RequestPayload {
    pulsemAccountId: number|null;
    socialMedia: SocialMediaSources|null;
    rating: string|number|null;
    count: string|number|null;
}

interface SocialMediaUrl {
    socialMediaId: number;
    source: SocialMediaSources;
}

interface ResponsePayload extends DefaultServerResponse {
    data: {
        pulsemAccountId: number;
        socialMediaUrls: SocialMediaUrl[];
    };
}

interface SelectItem {
    text: SocialMediaTitles;
    value: SocialMediaSources;
}


@Component({
    components: {
        AccountIdInput,
        TechTaskCard
    }
})
export default class SocialMediaCapture extends Vue {
    locationValid = false
    pulsemAccountId: number|null = null
    socialMedia: SocialMediaSources|null = null
    rating: string|number|null = null
    count: string|number|null = null
    socialMediaUrls: Array<SocialMediaUrl> = []

    get requestPayload(): RequestPayload {
        return {
            pulsemAccountId: this.pulsemAccountId,
            socialMedia: this.socialMedia,
            rating: typeof this.rating === 'string' ? parseFloat(this.rating) : this.rating,
            count: typeof this.count === 'string' ? parseInt(this.count) : this.count
        }
    }

    get selectSocialMediaUrls(): Array<SelectItem> {
        const selectItems = []
        for (const url of this.socialMediaUrls) {
            selectItems.push({
                text: SocialMediaTitles[url.source],
                value: url.source
            })
        }
        return selectItems
    }

    async loadSocialMedias(): Promise<ResponsePayload> {
        return await request.post('/support/social-media-capture-load/load', {
            pulsemAccountId: this.pulsemAccountId
        }) as ResponsePayload
    }

    async onLocationChange(locationValid: boolean) {
        this.locationValid = locationValid
        this.socialMedia = null
        this.rating = null
        this.count = null
        if (this.locationValid) {
            const response = await this.loadSocialMedias()
            this.socialMediaUrls = response.data.socialMediaUrls
        } else {
            this.socialMediaUrls = []
        }
    }

    onSuccess(status: boolean) {
        if (status) {
            this.pulsemAccountId = null
            this.locationValid = false
            this.socialMedia = null
            this.rating = null
            this.count = null
        }
    }
}
